import {mapActions} from "vuex";

const rateMixin = {

    methods: {
        ...mapActions({
            getRateInfoAction: 'rate/getRateInfo',
            sendSocialClick: 'rate/sendSocialClick',
        }),

        async getRateInfo(question_id) {
            try {
                const response = await this.getRateInfoAction(question_id)
                if (response.data) {
                    this.place_info = response.data;
                    this.$store.commit('rate/setPlaceInfo', response.data)
                    if (this.place_info.place == null) {
                        localStorage.setItem('unlinked_rate', this.question_id);
                        localStorage.setItem('unlinked_rate_question', response.data.question);
                        if (response.data.location) {
                            localStorage.setItem('unlinked_rate_question_location', response.data.location);
                        }
                        this.$store.commit('owner/setOwner', true)
                        this.$router.push({
                            name: 'Login',
                            query: {type: 'linkQuestion'}
                        });
                    } else {
                        this.place_img = this.place_info.place.preview
                    }
                    this.handleGiveawaySettings()
                }
            } catch (error) {
                console.log('error', error)
                this.showErrorModal(error.data.error.message)
            }
        },

        handleGiveawaySettings() {
            let enabled = this.place_info.giveaway != null
            this.$store.commit('rate/setGiveawayEnabled', enabled)
            if (enabled) {
                this.$store.commit('rate/setGiveawayParticipates', enabled && this.place_info.giveaway.user_started)
                this.$store.commit('rate/setGiveawayDescription', this.place_info.giveaway.description)
                this.$store.commit('rate/setGiveawayTitle', this.place_info.giveaway.giveaway_title)
            } else {
                this.$store.commit('rate/clearGiveaway')
            }
        },

        async sendSocialClickToServer(voteUid, linkUid) {
            try {
                await this.sendSocialClick({
                    rateUid: voteUid,
                    linkUid: linkUid
                })
                return true
            } catch (error) {
                console.log('error sendSocialClick', error)
                return false
            }
        },

        navigateToVoteLogin(qUid = null, rateUid = null, rateValue = null) {
            let url = `${location.origin}/r/sign-up?`
            if(qUid) url += `qUid=${qUid}`
            if(rateUid) url += `&rateUid=${rateUid}`
            if(rateValue) url += `&rateValue=${rateValue}`
            window.location.replace(url)
        },
    }
};

export default rateMixin;
